import { render, staticRenderFns } from "./bo-select-popup.vue?vue&type=template&id=40014914"
import script from "./bo-select-popup.vue?vue&type=script&lang=js"
export * from "./bo-select-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports